module.exports = {
    'core.title': 'Titolo core demo',
    'ngDro-core.register': 'Registrati',
    'ngDro-core.registerNow': 'Registrati',
    'ngDro-core.remember': 'Ricordami',
    'ngDro-core.log-in' : 'Accedi',
    'ngDro-core.login' : 'Login',
    'ngDro-core.italian':'Italiano',
    'ngDro-core.english':'Inglese',
    'ngDro-core.log-out' : 'Logout'
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/languages/it.js
// module id = 307
// module chunks = 0